import React, { useCallback, useEffect, useState } from 'react'
import { withTranslation } from 'react-i18next'
import Btn, { FormBtn } from 'components/Btn'
import LinkItem from 'components/Link'
import StepOne from './StepOne'
import StepTwo from './StepTwo'
import StepThree from './StepThree'
import StepProgress from '../components/StepProgress'
import { useFormContext } from 'react-hook-form'
import { apiRequest } from 'store/Misc/apiRequest'
import { toast } from 'react-toastify'
import { ArrowRight, ArrowLeft } from 'lucide-react'

const STEP_LABELS = ['step_one', 'step_two', 'step_three']

export default withTranslation()(function RegistrationForm({ t, validationFields, steps: { step, setstep }, yupFields: { isDirty, isValid } }) {

  const { watch } = useFormContext()
  const [phoneErrorState, setPhoneErrorState] = useState(true) //check phone validation for each country
  const phoneError = watch('phoneError')
  useEffect(() => {
    if (step === 0) { setPhoneErrorState(phoneError) } else { setPhoneErrorState(true) }
  }, [phoneError, watch, step])

  const checkEmail = useCallback(async () => {
    try {
      await apiRequest({
        url: 'merchants/validate/email',
        method: 'post',
        payload: { email: watch('primary_email') }
      })
    } catch (error) {
      if (Error(error).message.includes('email')) {
        setstep(0)
        toast.error('This email is taken')
      }
    }
  }, [watch, setstep])

  useEffect(() => {
    checkEmail()
  }, [checkEmail])

  return (
    <div className="w-full text-left">
      <StepProgress step={step} totalSteps={validationFields.length} label={t(`registration.${STEP_LABELS[step]}.label`).toUpperCase()} />

      <h1 className="text-2xl font-bold text-black mb-1">{t(`registration.${STEP_LABELS[step]}.title`)}</h1>
      <p className="text-secondary mb-6">{t(`registration.${STEP_LABELS[step]}.content`)}</p>

      {
        formSwitcher(step)
      }

      <div className="flex gap-3 mt-7 items-center">
        {
          step > 0 && (
            <Btn
              content={() => <span className="flex items-center justify-center gap-1.5"><ArrowLeft size={16} /> {t('misc.back')}</span>}
              variant="outline"
              color="#111827"
              className="w-1/2 h-12 !rounded-full !border !border-border-lines"
              disabled={step === 0}
              click={() => setstep(step - 1)}
            />
          )
        }
        {
          step > 1 ? (
            <FormBtn
              content={() => <span className="flex items-center justify-center gap-2">{t(`registration.${STEP_LABELS[step]}.cta`)} <ArrowRight size={16} /></span>}
              className={`${step > 0 ? 'w-1/2' : 'w-full'} h-12 text-white rounded-full bg-primary hover:bg-primary`}
              disabled={!isValid || !isDirty}
            />
          ) : (
            <div className={`${step > 0 ? 'w-1/2' : 'w-full'} h-12 overflow-hidden`}>
              <Btn
                content={() => <span className="flex items-center justify-center gap-2">{t(`registration.${STEP_LABELS[step]}.cta`)} <ArrowRight size={16} /></span>}
                className="w-full h-12 text-white rounded-full bg-primary hover:bg-primary"
                disabled={(!isValid || !isDirty) || !phoneErrorState}
                click={() => setstep(step + 1)}
              />
            </div>
          )
        }
      </div>

      {
        step === 0 && (
          <p className="text-center text-secondary text-sm mt-6">
            {t('registration.registered')}{' '}
            <LinkItem url="/login" tag={() => <span className="text-primary font-medium">{t('registration.signin')}</span>} />
          </p>
        )
      }
    </div>
  )
})
const formSwitcher = (step) => {

  switch (step) {
    case 0:
      return <StepOne />

    case 1:
      return <StepTwo />

    case 2:
      return <StepThree />

    default:
      return
  }
}